import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=03bc7ffe&scoped=true&"
import script from "./wechatLogin.vue?vue&type=script&lang=js&"
export * from "./wechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./wechatLogin.vue?vue&type=style&index=0&id=03bc7ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc7ffe",
  null
  
)

export default component.exports